import client from "./client";

const AUTH_API = process.env.REACT_APP_AUTH_API || "http://localhost:5000/api/auth";
const BASE = AUTH_API.replace("/api/auth", "");

// ─── Email Sequences ───
export const fetchSequences = async (botId = "") => {
  let url = `${BASE}/api/email-sequences`;
  if (botId) url += `?botId=${botId}`;
  const res = await client.get(url);
  return res.data;
};

export const getSequence = async (id) => {
  const res = await client.get(`${BASE}/api/email-sequences/${id}`);
  return res.data;
};

export const createSequence = async (data) => {
  const res = await client.post(`${BASE}/api/email-sequences`, data);
  return res.data;
};

export const updateSequence = async (id, data) => {
  const res = await client.put(`${BASE}/api/email-sequences/${id}`, data);
  return res.data;
};

export const deleteSequence = async (id) => {
  const res = await client.delete(`${BASE}/api/email-sequences/${id}`);
  return res.data;
};

// ─── Email Campaigns ───
export const fetchCampaigns = async ({ botId = "", status = "" } = {}) => {
  const params = new URLSearchParams();
  if (botId) params.set("botId", botId);
  if (status) params.set("status", status);
  const qs = params.toString();
  const res = await client.get(`${BASE}/api/email-campaigns${qs ? "?" + qs : ""}`);
  return res.data;
};

export const getCampaign = async (id) => {
  const res = await client.get(`${BASE}/api/email-campaigns/${id}`);
  return res.data;
};

export const fetchCampaignStats = async (botId = "") => {
  let url = `${BASE}/api/email-campaigns/stats`;
  if (botId) url += `?botId=${botId}`;
  const res = await client.get(url);
  return res.data;
};

export const pauseCampaign = async (id) => {
  const res = await client.post(`${BASE}/api/email-campaigns/${id}/pause`, {});
  return res.data;
};

export const resumeCampaign = async (id) => {
  const res = await client.post(`${BASE}/api/email-campaigns/${id}/resume`, {});
  return res.data;
};

export const cancelCampaign = async (id) => {
  const res = await client.post(`${BASE}/api/email-campaigns/${id}/cancel`, {});
  return res.data;
};
